"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _nl = _interopRequireDefault(require("./nl"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var messages = {
  nl: _nl["default"]
};
exports.messages = messages;